/**
 * Start fetching the product page loader as soon as this bundle executes (end of body) instead of
 * waiting for DOM ready, so the configurator chunks are ready when init() runs.
 */
function load_product_page_loader() {
    return import(/* webpackPrefetch: true */ './components/product_page_loader');
}

function is_product_page_configurator(): boolean {
    const configurator_body = document.getElementById('js-config-v2-block');

    return !!configurator_body && configurator_body.dataset.location === 'product_page';
}

const product_page_loader = is_product_page_configurator() ? load_product_page_loader() : null;

export function init() {
    if (is_product_page_configurator()) {
        (product_page_loader ?? load_product_page_loader()).then(
            module => new module.ProductPageLoader()
        );
    }
}
